import { useEffect } from "react";

interface ShortcutHandlers {
  onFocusComposer: () => void;
  onStop: () => void;
  isLoading: boolean;
}

/**
 * Global keyboard shortcuts:
 *   - Ctrl/Cmd+K  : focus composer
 *   - Esc         : stop generation (when loading)
 * Enter / Shift+Enter / Ctrl+Enter are handled inside the composer's textarea.
 */
export function useKeyboardShortcuts({ onFocusComposer, onStop, isLoading }: ShortcutHandlers): void {
  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      const isMod = event.metaKey || event.ctrlKey;
      if (isMod && (event.key === "k" || event.key === "K")) {
        event.preventDefault();
        onFocusComposer();
        return;
      }
      if (event.key === "Escape" && isLoading) {
        event.preventDefault();
        onStop();
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onFocusComposer, onStop, isLoading]);
}
